/**
 * GraphQL Query: GetMe
 * Get current authenticated user information
 */
export const GET_ME = `
  query Me {
    me {
      id
      email
      username
      emailVerified
      groups
      roles
    }
  }
`;
//# sourceMappingURL=getMe.js.map